<template>
  <div class="Productcenter">
    <div class="pagestitle clearfix">
      <span class="pageslink">
          <li><router-link class="indexicon" to="/" /></li>
          <li><router-link to="/company">新闻中心</router-link> > </li><li><router-link class='cur' :to="cur">{{curName}}</router-link></li>
      </span>
      <h4>
        <span>{{curName}}</span>
        <img class="titleimg" :src="baseApi+'webimages/news.png'"  >
      </h4>
    </div>
    <div class="insidesnav clearfix">
      <router-link :class="cur === '/company' ? 'cur': ''" to="/company">公司新闻</router-link>
      <router-link :class="cur === '/product' ? 'cur': ''" to="/product">行业动态</router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cur: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/'
    }
  },
  computed: {
    curName () {
      switch (this.cur) {
        case '/company':
          return '公司新闻'
        case '/product':
          return '行业动态'
        default:
          return ''
      }
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/news/componets/Tab.vue